import "./main.css";
import {baseStyleProps as $1Thsl$baseStyleProps, useSlotProps as $1Thsl$useSlotProps, useStyleProps as $1Thsl$useStyleProps, classNames as $1Thsl$classNames} from "@react-spectrum/utils";
import {filterDOMProps as $1Thsl$filterDOMProps} from "@react-aria/utils";
import $1Thsl$react from "react";
import {useProvider as $1Thsl$useProvider} from "@react-spectrum/provider";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


var $6edfbdaffbc9baf9$exports = {};

$parcel$export($6edfbdaffbc9baf9$exports, "spectrum--large", () => $6edfbdaffbc9baf9$export$a88a8dbe29386d31, (v) => $6edfbdaffbc9baf9$export$a88a8dbe29386d31 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum--medium", () => $6edfbdaffbc9baf9$export$4c0c83b3f4303ef8, (v) => $6edfbdaffbc9baf9$export$4c0c83b3f4303ef8 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon", () => $6edfbdaffbc9baf9$export$d374b04f30360026, (v) => $6edfbdaffbc9baf9$export$d374b04f30360026 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeL", () => $6edfbdaffbc9baf9$export$8d23c37ef2a4f13e, (v) => $6edfbdaffbc9baf9$export$8d23c37ef2a4f13e = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeM", () => $6edfbdaffbc9baf9$export$8f1693ac47916bbf, (v) => $6edfbdaffbc9baf9$export$8f1693ac47916bbf = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeS", () => $6edfbdaffbc9baf9$export$34ce05647f0c65e, (v) => $6edfbdaffbc9baf9$export$34ce05647f0c65e = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeXL", () => $6edfbdaffbc9baf9$export$c6e70a22e841bc1b, (v) => $6edfbdaffbc9baf9$export$c6e70a22e841bc1b = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeXS", () => $6edfbdaffbc9baf9$export$557c0af6873b4222, (v) => $6edfbdaffbc9baf9$export$557c0af6873b4222 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeXXL", () => $6edfbdaffbc9baf9$export$b37777493a27e620, (v) => $6edfbdaffbc9baf9$export$b37777493a27e620 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-Icon--sizeXXS", () => $6edfbdaffbc9baf9$export$cab8448604b31f43, (v) => $6edfbdaffbc9baf9$export$cab8448604b31f43 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon", () => $6edfbdaffbc9baf9$export$c7db7fdc5aac13aa, (v) => $6edfbdaffbc9baf9$export$c7db7fdc5aac13aa = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon--large", () => $6edfbdaffbc9baf9$export$2265a487ad399d8b, (v) => $6edfbdaffbc9baf9$export$2265a487ad399d8b = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon--medium", () => $6edfbdaffbc9baf9$export$a6044013cf72ddc9, (v) => $6edfbdaffbc9baf9$export$a6044013cf72ddc9 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-AlertMedium", () => $6edfbdaffbc9baf9$export$83be8302c01b6478, (v) => $6edfbdaffbc9baf9$export$83be8302c01b6478 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-AlertSmall", () => $6edfbdaffbc9baf9$export$57b49d6ee2e9f187, (v) => $6edfbdaffbc9baf9$export$57b49d6ee2e9f187 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ArrowDownSmall", () => $6edfbdaffbc9baf9$export$81968d05e3681b3f, (v) => $6edfbdaffbc9baf9$export$81968d05e3681b3f = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ArrowLeftMedium", () => $6edfbdaffbc9baf9$export$c0d655f335b5bc31, (v) => $6edfbdaffbc9baf9$export$c0d655f335b5bc31 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-Asterisk", () => $6edfbdaffbc9baf9$export$cca4342eca45562, (v) => $6edfbdaffbc9baf9$export$cca4342eca45562 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CheckmarkMedium", () => $6edfbdaffbc9baf9$export$edc4a2e9af971b26, (v) => $6edfbdaffbc9baf9$export$edc4a2e9af971b26 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CheckmarkSmall", () => $6edfbdaffbc9baf9$export$9e665cb12e71e037, (v) => $6edfbdaffbc9baf9$export$9e665cb12e71e037 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronDownMedium", () => $6edfbdaffbc9baf9$export$2f91b7a7627906d5, (v) => $6edfbdaffbc9baf9$export$2f91b7a7627906d5 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronDownSmall", () => $6edfbdaffbc9baf9$export$56efb4ec9eb35c07, (v) => $6edfbdaffbc9baf9$export$56efb4ec9eb35c07 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronLeftLarge", () => $6edfbdaffbc9baf9$export$5861dfe1d581a528, (v) => $6edfbdaffbc9baf9$export$5861dfe1d581a528 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronLeftMedium", () => $6edfbdaffbc9baf9$export$595a122b60890c78, (v) => $6edfbdaffbc9baf9$export$595a122b60890c78 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronRightLarge", () => $6edfbdaffbc9baf9$export$596373794435f8bc, (v) => $6edfbdaffbc9baf9$export$596373794435f8bc = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronRightMedium", () => $6edfbdaffbc9baf9$export$32b379a02cafbfb3, (v) => $6edfbdaffbc9baf9$export$32b379a02cafbfb3 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronRightSmall", () => $6edfbdaffbc9baf9$export$ee5de2c4d7c8faa4, (v) => $6edfbdaffbc9baf9$export$ee5de2c4d7c8faa4 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ChevronUpSmall", () => $6edfbdaffbc9baf9$export$c1cbae72fd236fd9, (v) => $6edfbdaffbc9baf9$export$c1cbae72fd236fd9 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CornerTriangle", () => $6edfbdaffbc9baf9$export$636d8cde4f6b7e6, (v) => $6edfbdaffbc9baf9$export$636d8cde4f6b7e6 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CrossLarge", () => $6edfbdaffbc9baf9$export$1f0ad4082256e3df, (v) => $6edfbdaffbc9baf9$export$1f0ad4082256e3df = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CrossMedium", () => $6edfbdaffbc9baf9$export$1e0848411e254295, (v) => $6edfbdaffbc9baf9$export$1e0848411e254295 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-CrossSmall", () => $6edfbdaffbc9baf9$export$1c1bddac0ae5fbe5, (v) => $6edfbdaffbc9baf9$export$1c1bddac0ae5fbe5 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-DashSmall", () => $6edfbdaffbc9baf9$export$98de2b9917cd3b6a, (v) => $6edfbdaffbc9baf9$export$98de2b9917cd3b6a = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-DoubleGripper", () => $6edfbdaffbc9baf9$export$3c956876cb11c1e1, (v) => $6edfbdaffbc9baf9$export$3c956876cb11c1e1 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-FolderBreadcrumb", () => $6edfbdaffbc9baf9$export$55cf2795737352fc, (v) => $6edfbdaffbc9baf9$export$55cf2795737352fc = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-HelpMedium", () => $6edfbdaffbc9baf9$export$d5d1e3e09ea6cd5, (v) => $6edfbdaffbc9baf9$export$d5d1e3e09ea6cd5 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-HelpSmall", () => $6edfbdaffbc9baf9$export$f51b22382127207d, (v) => $6edfbdaffbc9baf9$export$f51b22382127207d = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-InfoMedium", () => $6edfbdaffbc9baf9$export$825a6c2340d3b7e5, (v) => $6edfbdaffbc9baf9$export$825a6c2340d3b7e5 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-InfoSmall", () => $6edfbdaffbc9baf9$export$4828f4a6bfd26c04, (v) => $6edfbdaffbc9baf9$export$4828f4a6bfd26c04 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-ListGripper", () => $6edfbdaffbc9baf9$export$1254ece141a8dac6, (v) => $6edfbdaffbc9baf9$export$1254ece141a8dac6 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-Magnifier", () => $6edfbdaffbc9baf9$export$a33650c9f4cc191e, (v) => $6edfbdaffbc9baf9$export$a33650c9f4cc191e = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-SkipLeft", () => $6edfbdaffbc9baf9$export$9eb19533e4b8cc28, (v) => $6edfbdaffbc9baf9$export$9eb19533e4b8cc28 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-SkipRight", () => $6edfbdaffbc9baf9$export$67704939e41f705a, (v) => $6edfbdaffbc9baf9$export$67704939e41f705a = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-Star", () => $6edfbdaffbc9baf9$export$c4d219c150b98c92, (v) => $6edfbdaffbc9baf9$export$c4d219c150b98c92 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-StarOutline", () => $6edfbdaffbc9baf9$export$bcda0a6a6d7202af, (v) => $6edfbdaffbc9baf9$export$bcda0a6a6d7202af = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-SuccessMedium", () => $6edfbdaffbc9baf9$export$d18d2d837989a797, (v) => $6edfbdaffbc9baf9$export$d18d2d837989a797 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-SuccessSmall", () => $6edfbdaffbc9baf9$export$506ac7a1a72a2c65, (v) => $6edfbdaffbc9baf9$export$506ac7a1a72a2c65 = v);
$parcel$export($6edfbdaffbc9baf9$exports, "spectrum-UIIcon-TripleGripper", () => $6edfbdaffbc9baf9$export$12b8600bcd969018, (v) => $6edfbdaffbc9baf9$export$12b8600bcd969018 = v);
var $6edfbdaffbc9baf9$export$a88a8dbe29386d31;
var $6edfbdaffbc9baf9$export$4c0c83b3f4303ef8;
var $6edfbdaffbc9baf9$export$d374b04f30360026;
var $6edfbdaffbc9baf9$export$8d23c37ef2a4f13e;
var $6edfbdaffbc9baf9$export$8f1693ac47916bbf;
var $6edfbdaffbc9baf9$export$34ce05647f0c65e;
var $6edfbdaffbc9baf9$export$c6e70a22e841bc1b;
var $6edfbdaffbc9baf9$export$557c0af6873b4222;
var $6edfbdaffbc9baf9$export$b37777493a27e620;
var $6edfbdaffbc9baf9$export$cab8448604b31f43;
var $6edfbdaffbc9baf9$export$c7db7fdc5aac13aa;
var $6edfbdaffbc9baf9$export$2265a487ad399d8b;
var $6edfbdaffbc9baf9$export$a6044013cf72ddc9;
var $6edfbdaffbc9baf9$export$83be8302c01b6478;
var $6edfbdaffbc9baf9$export$57b49d6ee2e9f187;
var $6edfbdaffbc9baf9$export$81968d05e3681b3f;
var $6edfbdaffbc9baf9$export$c0d655f335b5bc31;
var $6edfbdaffbc9baf9$export$cca4342eca45562;
var $6edfbdaffbc9baf9$export$edc4a2e9af971b26;
var $6edfbdaffbc9baf9$export$9e665cb12e71e037;
var $6edfbdaffbc9baf9$export$2f91b7a7627906d5;
var $6edfbdaffbc9baf9$export$56efb4ec9eb35c07;
var $6edfbdaffbc9baf9$export$5861dfe1d581a528;
var $6edfbdaffbc9baf9$export$595a122b60890c78;
var $6edfbdaffbc9baf9$export$596373794435f8bc;
var $6edfbdaffbc9baf9$export$32b379a02cafbfb3;
var $6edfbdaffbc9baf9$export$ee5de2c4d7c8faa4;
var $6edfbdaffbc9baf9$export$c1cbae72fd236fd9;
var $6edfbdaffbc9baf9$export$636d8cde4f6b7e6;
var $6edfbdaffbc9baf9$export$1f0ad4082256e3df;
var $6edfbdaffbc9baf9$export$1e0848411e254295;
var $6edfbdaffbc9baf9$export$1c1bddac0ae5fbe5;
var $6edfbdaffbc9baf9$export$98de2b9917cd3b6a;
var $6edfbdaffbc9baf9$export$3c956876cb11c1e1;
var $6edfbdaffbc9baf9$export$55cf2795737352fc;
var $6edfbdaffbc9baf9$export$d5d1e3e09ea6cd5;
var $6edfbdaffbc9baf9$export$f51b22382127207d;
var $6edfbdaffbc9baf9$export$825a6c2340d3b7e5;
var $6edfbdaffbc9baf9$export$4828f4a6bfd26c04;
var $6edfbdaffbc9baf9$export$1254ece141a8dac6;
var $6edfbdaffbc9baf9$export$a33650c9f4cc191e;
var $6edfbdaffbc9baf9$export$9eb19533e4b8cc28;
var $6edfbdaffbc9baf9$export$67704939e41f705a;
var $6edfbdaffbc9baf9$export$c4d219c150b98c92;
var $6edfbdaffbc9baf9$export$bcda0a6a6d7202af;
var $6edfbdaffbc9baf9$export$d18d2d837989a797;
var $6edfbdaffbc9baf9$export$506ac7a1a72a2c65;
var $6edfbdaffbc9baf9$export$12b8600bcd969018;
$6edfbdaffbc9baf9$export$a88a8dbe29386d31 = `yxBNXG_spectrum--large`;
$6edfbdaffbc9baf9$export$4c0c83b3f4303ef8 = `yxBNXG_spectrum--medium`;
$6edfbdaffbc9baf9$export$d374b04f30360026 = `yxBNXG_spectrum-Icon`;
$6edfbdaffbc9baf9$export$8d23c37ef2a4f13e = `yxBNXG_spectrum-Icon--sizeL`;
$6edfbdaffbc9baf9$export$8f1693ac47916bbf = `yxBNXG_spectrum-Icon--sizeM`;
$6edfbdaffbc9baf9$export$34ce05647f0c65e = `yxBNXG_spectrum-Icon--sizeS`;
$6edfbdaffbc9baf9$export$c6e70a22e841bc1b = `yxBNXG_spectrum-Icon--sizeXL`;
$6edfbdaffbc9baf9$export$557c0af6873b4222 = `yxBNXG_spectrum-Icon--sizeXS`;
$6edfbdaffbc9baf9$export$b37777493a27e620 = `yxBNXG_spectrum-Icon--sizeXXL`;
$6edfbdaffbc9baf9$export$cab8448604b31f43 = `yxBNXG_spectrum-Icon--sizeXXS`;
$6edfbdaffbc9baf9$export$c7db7fdc5aac13aa = `yxBNXG_spectrum-UIIcon`;
$6edfbdaffbc9baf9$export$2265a487ad399d8b = `yxBNXG_spectrum-UIIcon--large`;
$6edfbdaffbc9baf9$export$a6044013cf72ddc9 = `yxBNXG_spectrum-UIIcon--medium`;
$6edfbdaffbc9baf9$export$83be8302c01b6478 = `yxBNXG_spectrum-UIIcon-AlertMedium`;
$6edfbdaffbc9baf9$export$57b49d6ee2e9f187 = `yxBNXG_spectrum-UIIcon-AlertSmall`;
$6edfbdaffbc9baf9$export$81968d05e3681b3f = `yxBNXG_spectrum-UIIcon-ArrowDownSmall`;
$6edfbdaffbc9baf9$export$c0d655f335b5bc31 = `yxBNXG_spectrum-UIIcon-ArrowLeftMedium`;
$6edfbdaffbc9baf9$export$cca4342eca45562 = `yxBNXG_spectrum-UIIcon-Asterisk`;
$6edfbdaffbc9baf9$export$edc4a2e9af971b26 = `yxBNXG_spectrum-UIIcon-CheckmarkMedium`;
$6edfbdaffbc9baf9$export$9e665cb12e71e037 = `yxBNXG_spectrum-UIIcon-CheckmarkSmall`;
$6edfbdaffbc9baf9$export$2f91b7a7627906d5 = `yxBNXG_spectrum-UIIcon-ChevronDownMedium`;
$6edfbdaffbc9baf9$export$56efb4ec9eb35c07 = `yxBNXG_spectrum-UIIcon-ChevronDownSmall`;
$6edfbdaffbc9baf9$export$5861dfe1d581a528 = `yxBNXG_spectrum-UIIcon-ChevronLeftLarge`;
$6edfbdaffbc9baf9$export$595a122b60890c78 = `yxBNXG_spectrum-UIIcon-ChevronLeftMedium`;
$6edfbdaffbc9baf9$export$596373794435f8bc = `yxBNXG_spectrum-UIIcon-ChevronRightLarge`;
$6edfbdaffbc9baf9$export$32b379a02cafbfb3 = `yxBNXG_spectrum-UIIcon-ChevronRightMedium`;
$6edfbdaffbc9baf9$export$ee5de2c4d7c8faa4 = `yxBNXG_spectrum-UIIcon-ChevronRightSmall`;
$6edfbdaffbc9baf9$export$c1cbae72fd236fd9 = `yxBNXG_spectrum-UIIcon-ChevronUpSmall`;
$6edfbdaffbc9baf9$export$636d8cde4f6b7e6 = `yxBNXG_spectrum-UIIcon-CornerTriangle`;
$6edfbdaffbc9baf9$export$1f0ad4082256e3df = `yxBNXG_spectrum-UIIcon-CrossLarge`;
$6edfbdaffbc9baf9$export$1e0848411e254295 = `yxBNXG_spectrum-UIIcon-CrossMedium`;
$6edfbdaffbc9baf9$export$1c1bddac0ae5fbe5 = `yxBNXG_spectrum-UIIcon-CrossSmall`;
$6edfbdaffbc9baf9$export$98de2b9917cd3b6a = `yxBNXG_spectrum-UIIcon-DashSmall`;
$6edfbdaffbc9baf9$export$3c956876cb11c1e1 = `yxBNXG_spectrum-UIIcon-DoubleGripper`;
$6edfbdaffbc9baf9$export$55cf2795737352fc = `yxBNXG_spectrum-UIIcon-FolderBreadcrumb`;
$6edfbdaffbc9baf9$export$d5d1e3e09ea6cd5 = `yxBNXG_spectrum-UIIcon-HelpMedium`;
$6edfbdaffbc9baf9$export$f51b22382127207d = `yxBNXG_spectrum-UIIcon-HelpSmall`;
$6edfbdaffbc9baf9$export$825a6c2340d3b7e5 = `yxBNXG_spectrum-UIIcon-InfoMedium`;
$6edfbdaffbc9baf9$export$4828f4a6bfd26c04 = `yxBNXG_spectrum-UIIcon-InfoSmall`;
$6edfbdaffbc9baf9$export$1254ece141a8dac6 = `yxBNXG_spectrum-UIIcon-ListGripper`;
$6edfbdaffbc9baf9$export$a33650c9f4cc191e = `yxBNXG_spectrum-UIIcon-Magnifier`;
$6edfbdaffbc9baf9$export$9eb19533e4b8cc28 = `yxBNXG_spectrum-UIIcon-SkipLeft`;
$6edfbdaffbc9baf9$export$67704939e41f705a = `yxBNXG_spectrum-UIIcon-SkipRight`;
$6edfbdaffbc9baf9$export$c4d219c150b98c92 = `yxBNXG_spectrum-UIIcon-Star`;
$6edfbdaffbc9baf9$export$bcda0a6a6d7202af = `yxBNXG_spectrum-UIIcon-StarOutline`;
$6edfbdaffbc9baf9$export$d18d2d837989a797 = `yxBNXG_spectrum-UIIcon-SuccessMedium`;
$6edfbdaffbc9baf9$export$506ac7a1a72a2c65 = `yxBNXG_spectrum-UIIcon-SuccessSmall`;
$6edfbdaffbc9baf9$export$12b8600bcd969018 = `yxBNXG_spectrum-UIIcon-TripleGripper`;



function $6bfb67578ee6effd$var$iconColorValue(value) {
    return `var(--spectrum-semantic-${value}-color-icon)`;
}
const $6bfb67578ee6effd$var$iconStyleProps = {
    ...(0, $1Thsl$baseStyleProps),
    color: [
        "color",
        $6bfb67578ee6effd$var$iconColorValue
    ]
};
function $6bfb67578ee6effd$export$f04a61298a47a40f(props) {
    props = (0, $1Thsl$useSlotProps)(props, "icon");
    let { children: children, size: size, "aria-label": ariaLabel, "aria-hidden": ariaHidden, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $1Thsl$useStyleProps)(otherProps, $6bfb67578ee6effd$var$iconStyleProps);
    let provider = (0, $1Thsl$useProvider)();
    let scale = "M";
    if (provider !== null) scale = provider.scale === "large" ? "L" : "M";
    if (!ariaHidden) ariaHidden = undefined;
    // Use user specified size, falling back to provider scale if size is undef
    let iconSize = size ? size : scale;
    return /*#__PURE__*/ (0, $1Thsl$react).cloneElement(children, {
        ...(0, $1Thsl$filterDOMProps)(otherProps),
        ...styleProps,
        focusable: "false",
        "aria-label": ariaLabel,
        "aria-hidden": ariaLabel ? ariaHidden || undefined : true,
        role: "img",
        className: (0, $1Thsl$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($6edfbdaffbc9baf9$exports))), children.props.className, "spectrum-Icon", `spectrum-Icon--size${iconSize}`, styleProps.className)
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




function $9ba43a63383852e3$export$906cc5990ff10700(props) {
    props = (0, $1Thsl$useSlotProps)(props, "icon");
    let { children: children, "aria-label": ariaLabel, "aria-hidden": ariaHidden, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $1Thsl$useStyleProps)(otherProps);
    let provider = (0, $1Thsl$useProvider)();
    let scale = "M";
    if (provider !== null) scale = provider.scale === "large" ? "L" : "M";
    if (!ariaHidden) ariaHidden = undefined;
    return /*#__PURE__*/ (0, $1Thsl$react).cloneElement(children, {
        ...(0, $1Thsl$filterDOMProps)(otherProps),
        ...styleProps,
        scale: scale,
        focusable: "false",
        "aria-label": ariaLabel,
        "aria-hidden": ariaLabel ? ariaHidden || undefined : true,
        role: "img",
        className: (0, $1Thsl$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($6edfbdaffbc9baf9$exports))), children.props.className, "spectrum-Icon", {
            [`spectrum-UIIcon-${children.type["displayName"]}`]: children.type["displayName"]
        }, styleProps.className)
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $88bb85359d3a4aed$export$d43c2e2ca9b2c105(props) {
    props = (0, $1Thsl$useSlotProps)(props, "illustration");
    let { children: children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, "aria-hidden": ariaHidden, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $1Thsl$useStyleProps)(otherProps);
    let hasLabel = ariaLabel || ariaLabelledby;
    if (!ariaHidden) ariaHidden = undefined;
    return /*#__PURE__*/ (0, $1Thsl$react).cloneElement(children, {
        ...(0, $1Thsl$filterDOMProps)(otherProps),
        ...styleProps,
        focusable: "false",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-hidden": ariaHidden,
        role: hasLabel ? "img" : undefined
    });
}




export {$6bfb67578ee6effd$export$f04a61298a47a40f as Icon, $9ba43a63383852e3$export$906cc5990ff10700 as UIIcon, $88bb85359d3a4aed$export$d43c2e2ca9b2c105 as Illustration};
//# sourceMappingURL=module.js.map
